module.exports = "<form>\n    <div>\n        {{'quoteandbind.pa.directives.templates.pa-quick-address-invalid.We can’t offer a quick quote for your location. If you would like to speak with an agent please call' | translate}}\n    </div>\n    <div class=\"gw-flip-card-bottom\">\n        <button class=\"gw-icon-primary\" ng-show=\"model.cancellable()\" ng-click=\"model.cancel()\" type=\"submit\">\n            <i class=\"fa fa-close gw-slq-icon-button\"></i>\n        </button>\n    </div>\n</form>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/directives/templates/pa-quick-address-invalid-state.html
 ** module id = 828
 ** module chunks = 0
 **/